import { createElement } from 'react';
import { useUniqueId } from './uniqueId.js';
import { string, node, shape, oneOfType, element, bool, func } from 'prop-types';
import { a as _objectSpread, b as _objectWithoutPropertiesLoose, c as _extends } from './chunk-ad6ad343.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import Flex from 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import { cardCardPropTypes, cardCardDefaultProps } from './Card/CardCard.js';
import _Callout, { CalloutTitle, CalloutIcon, CalloutHeader, CalloutContent, CalloutFooter } from './Callout/styled.js';
import CalloutClose, { calloutClosePropTypes } from './Callout/CalloutClose.js';

var Callout = function Callout(_ref) {
  var _a11yDescriptionId = _ref.a11yDescriptionId,
      _a11yTitleId = _ref.a11yTitleId,
      children = _ref.children,
      closeButtonProps = _ref.closeButtonProps,
      footer = _ref.footer,
      hasTint = _ref.hasTint,
      icon = _ref.icon,
      onClickClose = _ref.onClickClose,
      showCloseButton = _ref.showCloseButton,
      title = _ref.title,
      type = _ref.type,
      props = _objectWithoutPropertiesLoose(_ref, ["a11yDescriptionId", "a11yTitleId", "children", "closeButtonProps", "footer", "hasTint", "icon", "onClickClose", "showCloseButton", "title", "type"]);

  var titleId = useUniqueId('Callout');
  var descriptionId = useUniqueId('Callout');
  var a11yDescriptionId = _a11yDescriptionId || descriptionId;
  var a11yTitleId = _a11yTitleId || titleId;
  return createElement(_Callout, _extends({
    a11yDescriptionId: a11yDescriptionId,
    a11yTitleId: a11yTitleId,
    hasTint: hasTint,
    type: type
  }, props), createElement(Flex, null, (type || icon) && createElement(CalloutTitle, null, createElement(CalloutIcon, {
    icon: type || icon,
    color: type
  })), createElement(Box, null, title && createElement(CalloutHeader, null, typeof title === 'string' ? createElement(CalloutTitle, {
    id: a11yTitleId
  }, title) : title), createElement(CalloutContent, {
    id: a11yDescriptionId
  }, children), footer && createElement(CalloutFooter, null, footer))), showCloseButton && createElement(CalloutClose, _extends({
    onClickClose: onClickClose
  }, closeButtonProps)));
};

var calloutPropTypes = _objectSpread({
  a11yDescriptionId: string,
  a11yTitleId: string,
  children: node.isRequired,
  className: string,
  closeButtonProps: shape(calloutClosePropTypes),
  footer: oneOfType([string, element]),
  hasTint: bool,
  icon: string,
  onClickClose: func,
  showCloseButton: bool,
  title: oneOfType([string, element]),
  type: string
}, cardCardPropTypes);

Callout.propTypes = calloutPropTypes;

var calloutDefaultProps = _objectSpread({}, cardCardDefaultProps, {
  a11yDescriptionId: undefined,
  a11yTitleId: undefined,
  children: undefined,
  className: undefined,
  closeButtonProps: {},
  footer: undefined,
  hasTint: false,
  icon: undefined,
  onClickClose: undefined,
  showCloseButton: false,
  title: undefined,
  type: undefined
});

Callout.defaultProps = calloutDefaultProps; // @ts-ignore

var C = Callout;
export { C as a, calloutPropTypes as b, calloutDefaultProps as c };